import { useAIAgentCenterContext } from 'contexts/ai-agent-center';
import { aiAgentCenterMessages, omniChatMessages } from 'messages';
import React, { memo } from 'react';
import { twMerge } from 'tailwind-merge';

const AIAgentCenterHeader: React.FC = () => {
  const { setTab, tab } = useAIAgentCenterContext();

  return (
    <div className='flex h-[76px] items-center justify-center gap-2 border-b'>
      <div
        onClick={() => setTab('ongoing')}
        className={twMerge(
          'flex h-9 cursor-pointer items-center gap-2 rounded-full border px-4',
          tab === 'ongoing' && 'bg-[#222A41] text-white'
        )}
      >
        <span className='text-sm font-semibold'>{aiAgentCenterMessages.onGoing}</span>
      </div>

      <div
        onClick={() => setTab('history')}
        className={twMerge(
          'flex h-9 cursor-pointer items-center gap-2 rounded-full border px-4',
          tab === 'history' && 'bg-[#222A41] text-white'
        )}
      >
        <span className='text-sm font-semibold'>{aiAgentCenterMessages.historiesSupport}</span>
      </div>
    </div>
  );
};
export default memo(AIAgentCenterHeader);
